import type { ReactNode } from 'react';

/** Agrupa skeletons visuales y anuncia la carga sin repetir texto visible. */
export function SkeletonState({
  label,
  children,
  className = '',
}: {
  label: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div role="status" aria-busy="true" className={className}>
      <span className="sr-only">{label}</span>
      {children}
    </div>
  );
}
